var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70098 14.9564L7.21141 12.5089C6.93484 12.237 6.49135 12.237 6.21478 12.5089C5.93147 12.7874 5.93147 13.2441 6.21478 13.5226L8.99991 16.2608C9.38902 16.6433 10.0129 16.6433 10.4021 16.2608L17.7837 9.00364C18.067 8.72511 18.067 8.26844 17.7837 7.98991C17.5071 7.718 17.0636 7.718 16.787 7.98991L9.70098 14.9564Z",
    fill: "#00CC52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/Approve.14339681.svg";
export { ForwardRef as ReactComponent };